export default "__VITE_PUBLIC_ASSET__48983f37__"